/*
  Состояние списка «выяснить у поставщика связи» - 05.10.2026, С-4.

  Хук знает про сервер, блок `StuckActions.jsx` - только про разметку. Ошибка
  отметки хранится по строке: показывается она рядом с кнопкой, которую нажали,
  а не общей плашкой над списком (правило 3 скилла frontend).
*/

import { useCallback, useState } from 'react'

import { api } from '../api/client.js'
import usePagedList from './usePagedList.js'

/*
  21.10.2026: список приходит страницей с сервера (требование владельца: «пагинация
  серверная»): `actions` - строки текущей страницы, `total` - сколько обращений неизвестно
  всего, `bar` - свойства общей панели. После отметки страница перечитывается: отмеченное
  из списка уходит, а если страница опустела, хук сам переходит на последнюю существующую.
*/
export default function useStuckActions() {
  const load = useCallback((window) => api.stuckActions(window), [])
  const { rows, total, error, reload, bar } = usePagedList(load)
  const [busyId, setBusyId] = useState(null)
  const [rowErrors, setRowErrors] = useState({})
  const [marked, setMarked] = useState(null)

  const mark = useCallback(
    async (action, happened) => {
      setBusyId(action.action_id)
      setRowErrors((current) => ({ ...current, [action.action_id]: null }))
      try {
        await api.markStuckAction(action.action_id, happened)
        setMarked({ action, happened })
        // Успех сразу обновляет список: отмеченное из него уходит.
        reload()
      } catch (failure) {
        setRowErrors((current) => ({ ...current, [action.action_id]: failure }))
      } finally {
        setBusyId(null)
      }
    },
    [reload],
  )

  return { actions: rows, total, bar, loadError: error, busyId, rowErrors, marked, mark }
}
